import { defineStore } from 'pinia'

interface State {
  shop_order_count: {
    cancel_request: number,
    complained: number,
    new: number,
    waiting_payment: number,
  },
  shop_order_payment_count: {
    pending: number,
  },
  reviews_count: {
    need_moderation: number,
  },

}

export const useDashboardStore = defineStore('Dashboard', {
  state: (): State => ({
    shop_order_count: {
      cancel_request: 0,
      complained: 0,
      new: 0,
      waiting_payment: 0,
    },
    shop_order_payment_count: {
      pending: 0,
    },
    reviews_count: {
      need_moderation: 0,
    },
  }),
  getters: {
    //
  },
  actions: {
    setOrdersCountNew (total: number) {
      this.shop_order_count.new = total
    },
    setOrdersCountWaitingPayment (total: number) {
      this.shop_order_count.waiting_payment = total
    },
    setOrdersCountComplained (total: number) {
      this.shop_order_count.complained = total
    },
    setOrdersCountCancelRequest (total: number) {
      this.shop_order_count.cancel_request = total
    },
    setShopOrdersPaymentPending (total: number) {
      this.shop_order_payment_count.pending = total
    },
    setReviewsCount (total: number) {
      this.reviews_count.need_moderation = total
    },
  },
})
